export default __webpack_public_path__ + "static/media/trust-logo.2dbbd94c.svg";